import Repository from './Repository'

const action = 'ttns'
const multipart = { headers: { 'Content-Type': 'multipart/form-data' } }

export default {
  getList(id) {
    return Repository.get(action + '?response_id=' + id)
  },
  postItem(data) {
    return Repository.post(action, data, multipart)
  },
  updateItem(id, data) {
    return Repository.post(`${action}/${id}`, data, multipart)
  },
  setDataToFormData(formData, type) {
    const formFile = new FormData()
    let typeFile

    switch (type) {
      case 'front':
        typeFile = { name: 'fileFront', type: 'front' }
        break
      case 'back':
        typeFile = { name: 'fileBack', type: 'back' }
        break
      case 'backTn':
        typeFile = { name: 'fileBackTn', type: 'backTn' }
        break
      case 'frontTn':
        typeFile = { name: 'fileFrontTn', type: 'frontTn' }
        break
      default:
        typeFile = {}
    }

    formFile.append('file', formData.get(typeFile.name))
    formFile.append('name', typeFile.type)

    return formFile
  },
  upload(ttnId, formData, type) {
    const formFile = this.setDataToFormData(formData, type)

    return Repository.post(`${action}/${ttnId}/upload`, formFile, multipart)
  },
  updateUploadFile(ttnId, formData, type, fileId) {
    const formFile = this.setDataToFormData(formData, type)

    formFile.append('id', fileId)

    return Repository.post(
      `${action}/${ttnId}/update_file`,
      formFile,
      multipart,
    )
  },
  deleteFile(ttnId, id) {
    return Repository.post(`${action}/${ttnId}/delete_files`, { id })
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
